// extracted by mini-css-extract-plugin
module.exports = {"aggregatorPin4":"AggregatorPin4-module--aggregator-pin-4--3PiXl","title":"AggregatorPin4-module--title--3gtoF","thumbnail":"AggregatorPin4-module--thumbnail--1B1HY"};